/* Edmee New Moms landing: pack picker, buy now, sticky bar */
(function () {
  if (window.__nmLanding) return;
  window.__nmLanding = true;

  function selected(box) {
    return box.querySelector('input[type="radio"]:checked');
  }

  function syncLabel(box) {
    var input = selected(box);
    var label = box.querySelector('[data-nm-buy-label]');
    if (input && label) label.textContent = box.getAttribute('data-label') + ' · ' + input.getAttribute('data-price');
    document.querySelectorAll('[data-nm-sticky-price]').forEach(function (el) {
      if (input) el.textContent = input.getAttribute('data-price');
    });
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-nm-buybox]');
    if (box) syncLabel(box);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nm-buy]');
    if (!btn) return;
    var box = btn.closest('[data-nm-buybox]');
    var input = selected(box);
    var err = box.querySelector('[data-nm-error]');
    var variant = box.getAttribute('data-variant');
    err.hidden = true;
    if (!variant || !input) {
      err.textContent = 'Please choose a product for this section in the theme editor.';
      err.hidden = false;
      return;
    }
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant), quantity: Number(input.getAttribute('data-qty')) }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        var code = input.getAttribute('data-code');
        window.location.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
      })
      .catch(function () {
        btn.disabled = false;
        err.textContent = 'Something went wrong. Please try again.';
        err.hidden = false;
      });
  });


  // Smooth scroll for in-page links (#nm-how, #nm-packs ...). CSS handles modern browsers; this covers the rest.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#nm-"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  function initSticky() {
    var bar = document.querySelector('[data-nm-sticky]');
    if (!bar) return;
    var hero = document.querySelector('[data-nm-hero]');
    var boxes = document.querySelectorAll('[data-nm-buybox]');
    function update() {
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
      var inView = false;
      boxes.forEach(function (b) {
        var r = b.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) inView = true;
      });
      bar.classList.toggle('is-on', past && !inView);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('[data-nm-buybox]').forEach(syncLabel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();

/* Videos carousel: scroll buttons, dots, play one video at a time */
(function () {
  function init(root) {
    if (root.__nmVid) return;
    root.__nmVid = true;
    var track = root.querySelector('[data-nm-vid-track]');
    var prev = root.querySelector('[data-nm-vid-prev]');
    var next = root.querySelector('[data-nm-vid-next]');
    var dotsBox = root.querySelector('[data-nm-vid-dots]');
    if (!track) return;
    var dots = [];

    function cards() { return track.querySelectorAll('.nm-vid__card'); }
    // mobile: one dot per video; tablet and desktop: one dot per page of videos
    function perCard() { return window.innerWidth < 640; }
    function pages() {
      if (perCard()) return cards().length;
      return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth));
    }
    function build() {
      var n = pages();
      var mode = perCard() ? 'card' : 'page';
      root.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2);
      if (dots.length === n && dotsBox.getAttribute('data-mode') === mode) return update();
      dotsBox.innerHTML = '';
      dotsBox.setAttribute('data-mode', mode);
      dots = [];
      if (n > 1) {
        for (var i = 0; i < n; i++) {
          (function (i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'nm-vid__dot';
            d.setAttribute('aria-label', 'Go to ' + (mode === 'card' ? 'video ' : 'page ') + (i + 1));
            d.addEventListener('click', function () {
              var left = mode === 'card' ? cards()[i].offsetLeft - cards()[0].offsetLeft : i * track.clientWidth;
              track.scrollTo({ left: Math.min(left, track.scrollWidth - track.clientWidth), behavior: 'smooth' });
            });
            dotsBox.appendChild(d);
            dots.push(d);
          })(i);
        }
      }
      update();
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var pos = max > 0 ? track.scrollLeft / max : 0;
      var active = Math.round(pos * (dots.length - 1));
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', build);

    track.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nm-vid-play]');
      if (!btn) return;
      var card = btn.closest('.nm-vid__card');
      var video = card && card.querySelector('video');
      if (!video) return;
      track.querySelectorAll('video').forEach(function (v) { if (v !== video) v.pause(); });
      video.controls = true;
      video.play();
    });
    track.addEventListener('play', function (e) {
      var card = e.target.closest && e.target.closest('.nm-vid__card');
      track.querySelectorAll('.nm-vid__card').forEach(function (c) { c.classList.toggle('is-playing', c === card); });
    }, true);
    track.addEventListener('pause', function (e) {
      var card = e.target.closest && e.target.closest('.nm-vid__card');
      if (card) card.classList.remove('is-playing');
    }, true);

    build();
    window.addEventListener('load', build);
  }
  function all() { document.querySelectorAll('[data-nm-vid]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
